import { render, staticRenderFns } from "./clientEdit.vue?vue&type=template&id=a6631932&"
import script from "./clientEdit.vue?vue&type=script&lang=js&"
export * from "./clientEdit.vue?vue&type=script&lang=js&"
import style0 from "./clientEdit.vue?vue&type=style&index=0&id=a6631932&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports